import axios from 'axios';
// Utiliser une URL absolue pour développement
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth services
export const authService = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (userData) => api.post('/auth/register', userData),
  logout: () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  },
  me: () => api.get('/auth/me'),
  changePassword: (data) => api.put('/auth/change-password', data),
};

// Eleves services
export const elevesService = {
  getAll: (params) => api.get('/eleves', { params }),
  getById: (id) => api.get(`/eleves/${id}`),
  create: (data) => api.post('/eleves', data),
  update: (id, data) => api.put(`/eleves/${id}`, data),
  delete: (id) => api.delete(`/eleves/${id}`),
};

// Classes services
export const classesService = {
  getAll: (params) => api.get('/classes', { params }),
  getById: (id) => api.get(`/classes/${id}`),
  create: (data) => api.post('/classes', data),
  update: (id, data) => api.put(`/classes/${id}`, data),
  delete: (id) => api.delete(`/classes/${id}`),
};

// Inscriptions services
export const inscriptionsService = {
  getAll: (params) => api.get('/inscriptions', { params }),
  getById: (id) => api.get(`/inscriptions/${id}`),
  create: (data) => api.post('/inscriptions', data),
  update: (id, data) => api.put(`/inscriptions/${id}`, data),
  delete: (id) => api.delete(`/inscriptions/${id}`),
};

// Paiements services
export const paiementsService = {
  getAll: (params) => api.get('/paiements', { params }),
  getById: (id) => api.get(`/paiements/${id}`),
  create: (data) => api.post('/paiements', data),
  update: (id, data) => api.put(`/paiements/${id}`, data),
};

// Evaluations services
export const evaluationsService = {
  getAll: (params) => api.get('/evaluations', { params }),
  getById: (id) => api.get(`/evaluations/${id}`),
  create: (data) => api.post('/evaluations', data),
  update: (id, data) => api.put(`/evaluations/${id}`, data),
};

// Parents services
export const parentsService = {
  getAll: (params) => api.get('/parents', { params }),
  getById: (id) => api.get(`/parents/${id}`),
  create: (data) => api.post('/parents', data),
  update: (id, data) => api.put(`/parents/${id}`, data),
  delete: (id) => api.delete(`/parents/${id}`),
  linkEleve: (parentId, eleveId) => api.post(`/parents/${parentId}/link-eleve`, { eleve_id: eleveId }),
  unlinkEleve: (parentId, eleveId) => api.delete(`/parents/${parentId}/unlink-eleve/${eleveId}`),
};

// Reference data services
export const referenceService = {
  getProfessions: () => api.get('/professions'),
  getReligions: () => api.get('/religions'),
};

export default api;